<script>
    import { TOKEN_SESSION, USER , TOAST_MESSAGE} from "../../stores";
    import { Datatable, PaginationRowCount, PaginationButtons } from "svelte-simple-datatables";
    import { onMount } from "svelte";
    import * as Fx from '../../globals/Fx.js'
    import { createEventDispatcher } from "svelte";
    import GLOBALS from "../../globals/GLOBALS";
    import ButtonCircular from "../ButtonCircular.svelte";
    import html2pdf from '../../html2pdf/dist/html2pdf.bundle.js'
    import DatePicker from '../Calendar/DatePicker.svelte'
    
    
    String.prototype.lines = function() { return this.split(/\r*\n/); }
    String.prototype.lineCount = function() { return this.lines().length; }
    
    const dispatch = createEventDispatcher();
    
    export let periodo
    
    let DATOSTABLA
    let GENERARPDF
    let SELECTED = new Object()
    let showButtonPdf = false
    var sw = false
    let reportPDF
    let link
    let selectAll = true
    let selectedCount = 0
    let rows
    
    // $: {
    //     sw = false    
    //     Object.keys(SELECTED).forEach((key) => {
    //         console.log(SELECTED[key])
    //         if (SELECTED[key])
    //             sw = true
    //     })
    //     showButtonPdf = sw ? true : false
    // }

    $: {
        selectedCount = 0
        Object.keys(SELECTED).forEach((key) => {
            selectedCount += SELECTED[key] ? 1 : 0
        })
    }
    
    onMount(() =>{
        _LIQ_QUERY("SIMULAR_LIQUIDACION", {periodo})
    })

    Date.prototype.addDays = function(days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    }

    let fechaHoy = new Date();
    let fechaVence = new Date().addDays(15);
    let fechaLiquidacion = new Date();

    const onDateChange = d => {
        fechaHoy = d.detail;
        // var arr = fechaHoy.toString().split(" ")
        // console.log(arr)
        // const month = GLOBALS.MNUM[arr[1]]
        // const year = arr[3]
        // console.log(month, year)
        // periodo = `${year}${month}`
    };

    const onFechaVenceChange = d => {
        fechaVence = d.detail;
    }

    const onFechaLiquidacionChange = d => {
        fechaLiquidacion = d.detail;
    }
    
    const _LIQ_QUERY = async (QUERY, data) => {
        // const data = {};
        const URL = GLOBALS.URL;
        const bearer = "Bearer " + $TOKEN_SESSION;
        await fetch(`${URL}/API/liquidaciones/QUERY/${QUERY}`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                Authorization: bearer,
                "Content-type": "application/json;charset=UTF-8",
            },
        })
            // Handle success
            .then((response) => response.json()) // convert to json
            .then((json) => {
                if (json.result === "success") {
                    switch(QUERY){
                        case "SIMULAR_LIQUIDACION":
                            if (json.result === "success") {
                                DATOSTABLA = json.rows
                            }else{
                            }
                            TOAST_MESSAGE.set(json)
                        break;
                        case "UPDATE_IMPORTE_LIQUIDADO":
                            if (json.result === "success") {
                                json.message = "Los importes liquidados han sido confirmados!"
                                _close()
                            }else{
                            }
                            TOAST_MESSAGE.set(json)
                        break;
                    }
                }else{
                    TOAST_MESSAGE.set(json)
                    if (json.status === 403) TOKEN_SESSION.set(null)
                }
    
            }) //print data to console
            .catch((err) => -console.log("Request Failed", err)); // Catch errors
    };
    
    
    const _close = () => {
        dispatch("close")
    }

    const _generarLiquidaciones = () => {
        var sus_id_contrato = new Array()
        Object.keys(SELECTED).forEach((key) => {
            if (SELECTED[key]) {
                sus_id_contrato.push(SELECTED[key].sus_id_contrato)
            } 
        })
        
        const params = {
            periodo, sus_id_contrato, 
            liq_fecha_vence: fechaVence.toISOString().slice(0,10),
            liq_fecha_liquidacion: fechaLiquidacion.toISOString().slice(0,10)
        }
        _LIQ_QUERY("UPDATE_IMPORTE_LIQUIDADO", params)
    }
    
    const settings = {
            sortable: true,
            rowsPerPage:1000,
            columnFilter: true,
            labels: {
                search: "Buscar...", // search input placeholer
                filter: "Filtro", // filter inputs placeholder
                noRows: "Registro no encontrado",
                info: "Mostrando {start} a {end} de {rows} registros",
                previous: "Anterior",
                next: "Sguiente",
            },
            blocks: {
                searchInput: false,
                paginationButtons: false,
                paginationRowCount: false,
            }
        };
    
   
        const _multiSelectRow = (row) => {
            SELECTED[row.sus_id_contrato] = SELECTED[row.sus_id_contrato] === undefined || !SELECTED[row.sus_id_contrato] ? row : null
        }
    
        
    const _exportExcel = () => {
        let HTML = `<tabla>
                <thead>
                    <th data-key="num">#</th>
                    <th data-key="sus_id_contrato">Contrato Id</th>
                    <th data-key="sus_nombre">Nombre</th>
                    <th data-key="liq_csmo_energia">Consumo de Energía</th>
                    <th data-key="bas_base_gravable">Base Gravable</th>
                    <th data-key="bas_monto_minimo_liq">Monto Mínimo Liq</th>
                    <th data-key="bas_monto_minimo_importe">Importe Mínimo</th>
                    <th data-key="liq_importe_liquidado">Total Importe Liquidado</th>
                </thead>
            `
        DATOSTABLA.forEach(element => {
            HTML += `<tr>`
            Object.keys(element).forEach((key) => {
                // HTML += `<td>${element[key]}</td>`
                if ((`liq_csmo_energia|bas_base_gravable|bas_monto_minimo_liq|bas_monto_minimo_importe|liq_importe_liquidado`).indexOf(key) > -1){
                    if ((`bas_base_gravable`).indexOf(key) > -1){
                        HTML += `<td>${element[key].toString().cop()}</td>`
                    }else{
                        HTML += `<td>${Fx.formatter.format(element[key]).cop()}</td>`
                    }
                }else{
                    HTML += `<td>${element[key]}</td>`
                }
            })
            HTML += `</td>`
        })
        HTML += `</table>`

        const data = Fx.fnExcelReport(HTML, "Listado Simulación de Liquidación")
        link.setAttribute("href", data.data_type + ', ' + encodeURIComponent(Fx.myUTF8(data.tab_text)));
        link.setAttribute("download", "Simulados.xls")
        
    }

    const _toggleSelectAll = () => {
        DATOSTABLA.forEach((row) => {
            SELECTED[row.sus_id_contrato] = selectAll ? row : null
        })   
        selectAll = selectAll ? false : true
    }
    
    </script>
    
    <div class="datatable-container">
        <div class="d-flex direction-row justify-content-between">
            <h4>Simulación de Liquidaciones / Liquidar</h4>
            <!-- <div class="btn btn-danger align-self-end"  on:click={() => _close()}>Cerrar</div> -->
            <div class="d-flex direction-row justify-content-end position-relative">
                <div class="circular d-flex justify-content-center align-items-center" style="background-color:#2980b9" on:click={() => _toggleSelectAll()} title={"Seleccionar/Deseleccionar Todo" }>
                    {#if selectedCount === 0}
                         <!-- content here -->
                         <ion-icon name="checkmark-done-outline"></ion-icon>
                    {:else}
                         <span style="font-size: 0.8em;">{selectedCount}</span>
                    {/if}
                </div>
                <DatePicker
                    on:datechange={onFechaLiquidacionChange}
                    selected={fechaLiquidacion}
                    allwaysShow={false}
                    boxStyle={"background-color:#2c3e50;color:#fff"}
                    inputStyle={"background-color: #ffeb3b;border-radius:2em;width: 7em;color:#2c3e50;border: none;padding: 2px 4px 6px 4px;font-size:1em;text-align:left;font-weight:bold;text-align:center; margin:0 5px;"}
                    disabled={false}
                    reverse={true}
                 >
                    <span style="position:absolute; bottom:6px;left:28px; font-size:0.5em;">Fecha Liquidación</span>
                 </DatePicker>
                <DatePicker
                    on:datechange={onFechaVenceChange}
                    selected={fechaVence}
                    allwaysShow={false}
                    boxStyle={"background-color:#2c3e50;color:#fff"}
                    inputStyle={"background-color: yellow;border-radius:2em;width: 7em;color:#2c3e50;border: none;padding: 2px 4px 6px 4px;font-size:1em;text-align:left;font-weight:bold;text-align:center; margin:0 5px;"}
                    disabled={false}
                    reverse={true}
                 >
                    <span style="position:absolute; bottom:6px;left:28px; font-size:0.5em;">Fecha Vencimiento</span>
                 </DatePicker>
                 <a class="circular d-flex justify-content-center align-items-center" style="background-color:green"  id="link" bind:this={link} on:click={() => _exportExcel()}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-excel-fill" viewBox="0 0 16 16">
                        <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM5.884 6.68 8 9.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 10l2.233 2.68a.5.5 0 0 1-.768.64L8 10.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 10 5.116 7.32a.5.5 0 1 1 .768-.64z"/>
                      </svg>
                </a>
                <div class="circular d-flex justify-content-center align-items-center" style="background-color:tomato" on:click={() => _generarLiquidaciones()} title={"Confirmar Liquidaciones" }>
                    <ion-icon name="save-sharp"></ion-icon>
                </div>
                <div class="circular d-flex justify-content-center align-items-center" on:click={() => _close()} title={"Cerrar"}>
                    <ion-icon name="close-outline"></ion-icon>
                </div>
            </div>
        </div>
        
        {#if DATOSTABLA}
                <!-- content here -->
                <!-- {JSON.stringify(DATOSTABLA)} -->
                <Datatable {settings} data={DATOSTABLA} bind:dataRows={rows} id={"simulacion-table"}>
                <thead>
                    <tr>
                        <th data-key="num">#</th>
                        <th data-key="sus_id_contrato">Contrato Id</th>
                        <th data-key="sus_nombre">Nombre</th>
                        <th data-key="liq_csmo_energia">Consumo de Energía</th>
                        <th data-key="bas_base_gravable">Base Gravable</th>
                        <th data-key="bas_monto_minimo_liq">Monto Mínimo Liq</th>
                        <th data-key="bas_monto_minimo_importe">Importe Mínimo</th>
                        <th data-key="liq_importe_liquidado">Total Importe Liquidado</th>
                    </tr>
                </thead>
                <tbody>
                    {#if rows}
                        {#each $rows as row, idx}
                        <tr
                            class="{idx % 2 === 0 ? 'bg-par' : 'bg-impar'}  
                                    {SELECTED[row.sus_id_contrato] ? 'active' : ''}"
                            on:click={() => _multiSelectRow(row)}
                            
                        >
                                <td class="text-center" >{row.num}</td>
                                <td class="text-center" >{row.sus_id_contrato}</td>
                                <td class="text-start" >{row.sus_nombre}</td>
                                <td class="text-end" >{Fx.formatter.format(row.liq_csmo_energia).cop()}</td>
                                <td class="text-center" >{row.bas_base_gravable.toString().cop()}</td>
                                <td class="text-end" >{Fx.formatter.format(row.bas_monto_minimo_liq).cop()}</td>
                                <td class="text-end" >{Fx.formatter.format(row.bas_monto_minimo_importe).cop()}</td>
                                <td class="text-end" >{Fx.formatter.format(row.liq_importe_liquidado).cop()}</td>
                            </tr>
                        {/each}
                    {/if}
                </tbody>
            </Datatable>
        {:else if GENERARPDF}
            <div class="container">
                <!-- <div class="sheet" bind:this={reportPDF}>
    
                </div> -->
                <div class="center">
                    <div class="spinner-border text-warning" role="status">
                        <span class="visually-hidden">Cargando...</span>
                    </div>
                    <div class="p-1">Procesando</div>
                </div>
            </div>
        {/if}
    </div>
    <footer class="d-flex flex-row justify-content-start">
        <div class="d-flex flex-row">
            <PaginationButtons id={"simulacion-table"}/>
            <PaginationRowCount id={"simulacion-table"}/>
        </div>
    </footer>
    
    
    <style>
    
        footer {
            position: fixed;
            display: flex;
            background-color: #fff;
            bottom:0;
            width: 100%;
            padding: 10px;
        }
    
        th {
            min-width: 10em;
            text-align: left;
        }
    
        td {
            text-align: left;
            white-space: nowrap;
            padding: 10px 10px;
        }
    
        tr {
            cursor: pointer;
            color: #3f51b5b5;
            font-size: 0.8em;
            transition: background-color 500ms;
        }
    
        tr:hover {
            background-color:#14518d33;
            color: #2c3e50;
        }
    
        tr.active {
            background-color: #2c3e50 !important;
            color: #fff !important;
        }
    
        .datatable-container {
            height: 76vh;
            max-height: 100vh;
            padding-top: 12px;
            margin-bottom: 40px;
            /* margin: 20px 0; */
        }
    
        .bg-par {
            background-color: #fafcff;
        }
    
        .bg-impar {
            background-color: #f2f6ff;
        }
    
        .circular {
            height: 30px;
            width: 30px;
            border-radius: 50%;
            background-color: #2c3e50;
            color : #fff;
            cursor: pointer;
            transition: all 250ms;
            margin: 0 5px;
        }
    
        .circular:hover {
            transform: scale(1.2);
        }
    
        .container {
            /* background-color: rgb(44, 62, 80); */
            height: 70vh;
            padding: 20px;
            overflow-y: auto;
            display: flex;
            justify-content: center;
        }
    </style>
